import { GeoTargetOptionsData } from "../../../types/campaignTypes";

export const getStateNamesByIds = (
  geoTargetOptions: GeoTargetOptionsData,
  geoTargetIds: number[],
): { us: string[]; ca: string[] } => {
  const idSet = new Set(geoTargetIds);
  const us: string[] = [];
  const ca: string[] = [];

  for (const state of geoTargetOptions["United States"].states) {
    if (idSet.has(state.id)) us.push(state.name);
  }
  for (const state of geoTargetOptions.Canada.states) {
    if (idSet.has(state.id)) ca.push(state.name);
  }

  return { us, ca };
};
